import { Skeleton, Grid } from '@methanesat/ui-components';

export const OGINearEmissionsSkeleton = () => {
    return (
        <Grid container marginTop={3}>
            {/* Title */}
            <Grid size={{ xs: 12 }}>
                <Skeleton data-testid="ogi-near-emissions-skeleton" sx={{ fontSize: 24 }} />
            </Grid>

            {/* Subtitle */}
            <Grid size={{ xs: 12 }} marginTop={1}>
                <Skeleton variant="text" sx={{ fontSize: 20 }} width="90%" />
            </Grid>

            {/* Summary bars */}
            <Grid size={{ xs: 12 }} marginTop={2}>
                <Skeleton variant="rectangular" height={100} />
            </Grid>

            {/* Disclaimer */}
            <Grid size={{ xs: 12 }} marginTop={1}>
                <Skeleton variant="text" sx={{ fontSize: 70 }} />
            </Grid>

            {/* Button */}
            <Grid size={{ xs: 12 }} display="flex" justifyContent="center" marginTop={2} marginBottom={2}>
                <Skeleton variant="rectangular" height={32} width="80%" />
            </Grid>
        </Grid>
    );
};
